import { createClient } from "@supabase/supabase-js";

const host = 'https://qujbnzzaqfcftchwqfkn.supabase.co'
const public_key = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1amJuenphcWZjZnRjaHdxZmtuIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODQ0NTgxMDIsImV4cCI6MjAwMDAzNDEwMn0.GH9pZ-4Z6IfFLLCRCpM9J1CZWzUw6z3rROLmjfXv8dg'

const supabase = createClient(host, public_key)

export {supabase, host, public_key}